import { AuthContext } from "../context/AuthContext"
import { useContext } from 'react'

export const useAuthcontext = () => {
    const context = useContext(AuthContext)
    if(!context) {
        throw Error('useAuth context must be inside an auth context provider')
    }
    return context
}
